import { render, staticRenderFns } from "./SortLegalHelpCentre.vue?vue&type=template&id=3f0a2193&"
import script from "./SortLegalHelpCentre.vue?vue&type=script&lang=js&"
export * from "./SortLegalHelpCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports